import Cookies from 'js-cookie';
let uid=Cookies.get('userId')||''
/**
 * window.localStorage 浏览器永久缓存
 * @method set 设置永久缓存
 * @method get 获取永久缓存
 * @method remove 移除永久缓存
 * @method clear 移除全部永久缓存
 */
export const Local = {
	// 设置永久缓存
	set(key: string, val: any) {
		window.localStorage.setItem(key, JSON.stringify(val));
	},
	// 获取永久缓存
	get(key: string) {
		let json = <string>window.localStorage.getItem(key);
		return JSON.parse(json);
	},
	// 移除永久缓存
	remove(key: string) {
		window.localStorage.removeItem(key);
	},
	// 移除全部永久缓存
	clear() {
		window.localStorage.clear();
	},
};

/**
 * window.sessionStorage 浏览器临时缓存
 * @method set 设置临时缓存
 * @method get 获取临时缓存
 * @method remove 移除临时缓存
 * @method clear 移除全部临时缓存
 */
export const Session = {
	// 设置临时缓存
	set(key: string, val: any) {
		if (
			key === 'token'
		)
		return Cookies.set(key, val, { expires: 3650, path: '/' + import.meta.env.VITE_APP_NAME });
		if(key==`adminCookie_${uid}`){	
    let num = 1 //失效时间是几小时
     let time= new Date(new Date().getTime() + num * 60 * 60 * 1000);
  //  let time= new Date(new Date().getTime() +60 * 1000);
		return Cookies.set(key, val, { expires: time});
		}
		if (
			key === 'token' ||
			key === 'userName' ||
			key === 'userId' ||
			key === 'yayiFlag' ||
			key === 'userNumber' ||
			key === 'role' ||
			key === 'firstLogin' ||
			key === 'firstPay' ||
			key === 'cvFlag'||
			key === 'vipType'||
			key === 'phoneMd5'||
			key === 'phoneNumber'||
			key === 'bindInfo'||
			key === 'havePwd'||key==='lastToken'||key==='lastUserId'||
			key=='adminhavePwd'||key=='isShowModelTip'||key=='docChat'||key=='generateImage'||key=='TOKEN_KEY'||key=='inviteCode'||key=='yanzhicode'

		)
		return Cookies.set(key, val, {expires: 3650});
		window.sessionStorage.setItem(key, JSON.stringify(val));
	},
	// 获取临时缓存
	get(key: string) {
		if (
			key === 'token' ||
			key === 'userName' ||
			key === 'userId' ||
			key === 'yayiFlag' ||
			key === 'userNumber' ||
			key === 'role' ||
			key === 'firstLogin' ||
			key === 'firstPay' ||
			key === 'cvFlag'||
			key === 'vipType'||
			key === 'phoneMd5'||
			key === 'bindInfo'||
			key === 'phoneNumber'||
			key==="havePwd"||key==='lastToken'||key==='lastUserId'||key==`adminCookie_${uid}`||
			key=='adminhavePwd'||key=='isShowModelTip'||key=='docChat'||key=='generateImage'||key=='inviteCode'||key=='yanzhicode'
		)
			return Cookies.get(key);
		let json = <string>window.sessionStorage.getItem(key);
		return JSON.parse(json);
	},
	// 移除临时缓存
	remove(key: string) {
		if (key === 'token') return Cookies.remove(key);
		window.sessionStorage.removeItem(key);
	},
	clearItem(key:string){
		window.sessionStorage.removeItem(key);
		if(key==`adminCookie_${uid}`){
			Cookies.remove(key);
			return
		}
		Cookies.remove(key);
	},
	// 移除全部临时缓存
	clear() {
		Cookies.remove('token', {path: '/'});
		Cookies.remove('token', {path: '/admin'});
		Cookies.remove('token', {path: '/' + import.meta.env.VITE_APP_NAME});
		Cookies.remove('userName');
		Cookies.remove('userId');
		Cookies.remove('yayiFlag');
		Cookies.remove('firstLogin');
		Cookies.remove('firstPay');
		Cookies.remove('userNumber');
		Cookies.remove('role');
		Cookies.remove('cvFlag');
		Cookies.remove('vipType');
		Cookies.remove('phoneMd5');
		Cookies.remove('phoneNumber');
		Cookies.remove('bindInfo');
		Cookies.remove('havePwd');
		Cookies.remove('isShowModelTip');
		Cookies.remove(`adminCookie_${uid}`);
		Cookies.remove('docChat');
		Cookies.remove('generateImage');
		// Cookies.remove('adminCookie');
		// Cookies.remove('adminhavePwd');
		window.sessionStorage.clear();
	},
};
